import React from 'react';

import './business.css';

function Business() {
  return (
    <div className="business">
      <h1>Appraisals should be fair.</h1>
    </div>
  );
}

export default Business;